import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import { Icon } from '../../shared/components/Icon';

const ImageContainerWithInfoIcon = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

const BonusPromoImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 1em;
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-sizing: border-box;
`;

const InfoIconContainer = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.14);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
`;

const CloseButtonContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  max-width: 100vw;
  height: auto;
  background-color: #14171F;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.3);
  overflow: hidden;
  transition: transform 0.3s ease, padding 0.3s ease;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 20px;
  z-index: 1000;
  transform: ${({ translateY }) => `translateY(${translateY}px)`};
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.14);
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIconContainer = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.7);
`;

const PromoBannerWithInfoSheet = ({ image, infoComponent }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [translateY, setTranslateY] = useState(0);
  const startYRef = useRef(null);

  const toggleSheet = () => {
    setTranslateY(0);
    setIsOpen(prev => !prev);
  };

  // Touch event handlers for drag
  const handleTouchStart = (e) => {
    startYRef.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    const currentY = e.touches[0].clientY;
    const deltaY = currentY - startYRef.current;

    if (deltaY > 0) {
      setTranslateY(deltaY);
    }
  };

  const handleTouchEnd = () => {
    // if dragged down > 80px, close modal
    if (translateY > 80) {
      toggleSheet();
    } else {
      // snap back to original position
      setTranslateY(0);
    }
  };

  return (
    <>
      <ImageContainerWithInfoIcon>
        <BonusPromoImage
          src={image}
          alt={'Promo'}
        />
        <InfoIconContainer onClick={toggleSheet}>
          <Icon name={'info'} />
        </InfoIconContainer>
      </ImageContainerWithInfoIcon>

      {/* Modal portal */}
      {ReactDOM.createPortal(
        <>
          {isOpen && <Backdrop onClick={toggleSheet} />}
          {isOpen && (
            <CloseButtonContainer
              translateY={translateY}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <CloseButton
                onClick={toggleSheet}
                aria-label={'Close'}
              >
                <CloseIconContainer>
                  <Icon name={'close'} />
                </CloseIconContainer>
              </CloseButton>
              {infoComponent}
            </CloseButtonContainer>
          )}
        </>,
        document.body,
      )}
    </>
  );
};

export default PromoBannerWithInfoSheet;
